(function ($) {
  $(() => {
    const contactForm = $(".js-contact-form");

    if (!contactForm.length) {
      return;
    }

    const hiddenClass = "hidden";
    const errorClass = "has-error";
    const inputGroup = $(".js-input-group");
    const hiddenTextarea = $(".js-hidden-textarea");
    const otherPlaceCheckbox = $(".js-other-place");
    const hiddenItemToggler = $(".js-hidden-item-toggler");
    const nextStepButton = $(".js-next-step");
    const previousStepButton = $(".js-previous-step");
    const firstStep = $(".js-contact-form-first-step");
    const secondStep = $(".js-contact-form-second-step");
    const yearSelect = $(".js-operation-year-select");
    const quartersList = $(".js-quarters-list");
    const inputName = $(".js-validate-name");
    const inputFName = $(".js-validate-fname");
    const inputCompany = $(".js-validate-company");
    const inputPhone = $(".js-validate-phone");
    const inputEmail = $(".js-validate-email");
    const servicesCheckbox = $(".js-services-checkbox");
    const servicesHiddenCheckbox = $(".js-hidden-checkbox");
    const placesCheckbox = $(".js-places-checkbox");
    const placesMessage = $(".js-place-message");
    const successSubmitBlock = $(".js-success-submit");
    const mainContactSection = $(".js-main-contact-section");
    const windowWidth = $(window).width();
    const errorMessages = localize.translations.error_messages;

    otherPlaceCheckbox.change(function (e) {
      e.preventDefault();
      hiddenTextarea.toggleClass(hiddenClass);
    });

    hiddenItemToggler.change(function (e) {
      e.preventDefault();
      $(this).parent().next().toggleClass(hiddenClass);
    });

    servicesCheckbox.change(function () {
      servicesCheckbox.closest(inputGroup).removeClass(errorClass);
    });

    placesCheckbox.change(function () {
      placesCheckbox.closest(inputGroup).removeClass(errorClass);
    });

    servicesHiddenCheckbox.change(function () {
      servicesHiddenCheckbox.closest(inputGroup).removeClass(errorClass);
    });

    nextStepButton.on("click", function (e) {
      e.preventDefault();

      const firstStepIsValid = validateFirstStep();

      if (firstStepIsValid && windowWidth < 1199) {
        goToSecondStep();
        goToTop();
      } else if (firstStepIsValid) {
        goToSecondStep();
      }

      return;
    });

    previousStepButton.on("click", function (e) {
      e.preventDefault();
      goToFirstStep();
    });

    yearSelect.on("change", function () {
      quartersList.removeClass(hiddenClass);
    });

    function validateFirstStep() {
      const nameIsValid = validateText(inputName);
      const nameFIsValid = validateText(inputFName);
      const companyIsValid = validateText(inputCompany);
      const emailIsValid = validateEmail(inputEmail);
      const phoneIsValid = validatePhone(inputPhone);
      const servicesCheckboxIsValid = validateServicesCheckbox();
      const placesCheckboxIsValid = validatePlacesCheckbox();
      const hiddenServicesCheckboxIsValid = validateHiddenServicesCheckbox();
      const placesMessageIsValid = validateText(placesMessage);
      let firstStepIsValid = true;

      if (!nameIsValid) {
        inputName.parent().addClass(errorClass);
        inputName.next().text(errorMessages.required);
        firstStepIsValid = false;
      }

      if (!nameFIsValid) {
        inputFName.parent().addClass(errorClass);
        inputFName.next().text(errorMessages.required);
        firstStepIsValid = false;
      }

      if (!companyIsValid) {
        inputCompany.parent().addClass(errorClass);
        inputCompany.next().text(errorMessages.required);
        firstStepIsValid = false;
      }

      if (!emailIsValid) {
        inputEmail.parent().addClass(errorClass);
        inputEmail.next().text(errorMessages.format);
        firstStepIsValid = false;
      }

      if (!phoneIsValid) {
        inputPhone.parent().addClass(errorClass);
        inputPhone.next().text(errorMessages.format);
        firstStepIsValid = false;
      }

      if (!servicesCheckboxIsValid) {
        servicesCheckbox.closest(inputGroup).addClass(errorClass);
        firstStepIsValid = false;
      }

      if (servicesCheckboxIsValid && !hiddenServicesCheckboxIsValid) {
        servicesHiddenCheckbox.closest(inputGroup).addClass(errorClass);
        firstStepIsValid = false;
      }

      if (!placesCheckboxIsValid) {
        placesCheckbox.closest(inputGroup).addClass(errorClass);
        firstStepIsValid = false;
      }

      if (otherPlaceCheckbox.is(":checked") && !placesMessageIsValid) {
        hiddenTextarea.addClass(errorClass);
        firstStepIsValid = false;
      }

      return firstStepIsValid;
    }

    contactForm.submit((e) => {
      e.preventDefault();
      $(".js-mailchimp-message-contact").hide();
      const formData = contactForm.serializeArray();

      $.ajax({
        url: localize.ajaxurl,
        type: "POST",
        data: {
          action: "submit_contact_form",
          datas: formData,
        },
        error(error) {
          console.error(error);
        },
        success(data) {
          const result = JSON.parse(data);
          const fields = [...new Set(result.fields)];

          if (result.status == "success") {
            contactForm.hide();
            successSubmitBlock.show();
            mainContactSection.addClass("mb-xl-5");
            goToTop();
          } else if (result.status == "mailchimp_error") {
            $(".js-mailchimp-message-contact").show();
          } else {
            if (result.first_step_has_error) {
              goToFirstStep();
            }

            $(fields).each((i, e) => {
              contactForm
                .find(`[name=${e.field}]`)
                .closest(inputGroup)
                .addClass(errorClass);
              contactForm
                .find(`[name=${e.field}]`)
                .nextAll(".js-error-message")
                .text(e.message);
            });
          }
        },
      });
    });

    function validateText(input) {
      const value = input.val();
      return !value.replace(/ /g, "") == "";
    }

    function validateEmail(input) {
      const value = input.val();
      const regex =
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(value);
    }

    function validatePhone(input) {
      const value = input.val();
      const regex = /^[0-9-+]+$/;
      return regex.test(value);
    }

    function validateServicesCheckbox() {
      return !servicesCheckbox.filter(":checked").length < 1;
    }

    function validatePlacesCheckbox() {
      return !placesCheckbox.filter(":checked").length < 1;
    }

    function validateHiddenServicesCheckbox() {
      var parentCheckboxGroup = servicesCheckbox.filter(":checked").parent();
      var childrenCheckboxGroup = parentCheckboxGroup
        .next()
        .find(servicesHiddenCheckbox);
      return !childrenCheckboxGroup.filter(":checked").length < 1;
    }

    function goToFirstStep() {
      secondStep.fadeOut(0);
      firstStep.fadeIn(500);
    }

    function goToSecondStep() {
      firstStep.fadeOut(0);
      secondStep.fadeIn(500);
    }

    function goToTop() {
      $("html, body").animate({ scrollTop: contactForm.offset().top }, 450);
    }
  });
})(jQuery);
